import { connect } from 'react-redux';
import { compose, withHandlers } from 'recompose';
import { prop } from 'ramda';
import { getPOSData } from '@olxbr/mojo-jojo/selectors/pos';

import { getSelectedCharacteristic } from '../../../selectors';
import { sendEvent } from '../../../services/tracking';
import { toggleOlxProPopup, selectCharacteristic } from '../../../actions';
import Benefits from './Benefits';

const configureHandlers = withHandlers({
  handleClick: () => (link) => {
    sendEvent({
      event_type: 'click',
      object_detail: 'view_characteristic',
      data: {
        id: link,
      },
    });
  },
});

const mapStateToProps = state => ({
  funnelId: prop('funnelId', getPOSData(state)),
  selectedCharacteristic: getSelectedCharacteristic(state),
});

export default compose(
  configureHandlers,
  connect(mapStateToProps, { openModal: toggleOlxProPopup, selectCharacteristic }),
)(Benefits);
